module.exports = __webpack_public_path__ + "static/assets/c328a73ec962d58e4553a5281ea07d7a.png";